import React from "react";
import { Box, Divider, Text, VStack } from "@chakra-ui/react";
import { TextField } from "../fields/TextField/TextField";
import { SwitchField } from "../fields/SwitchField/SwitchField";

export const BusinessCustomerRiskManagementConfigurationSection = () => {
  return (
    <VStack w="100%" spacing={4} alignItems="flex-start">
      <Box
        w="100%"
        p={4}
        border="1px solid"
        borderColor="cherryButtonDark.50"
        borderRadius="md"
      >
        <Text fontSize="sm">
          <b>Bndry API Client Configuration</b>
        </Text>
        <Divider mb={2} />
        <VStack w="100%" spacing={4} alignItems="flex-start">
          <TextField
            horizontal
            valueProps={{ flex: 2 }}
            label="Client Id *"
            name="customerRiskManagementConfiguration.BndryApiClientConfiguration.ClientId"
          />
          <SwitchField
            horizontal
            valueProps={{ flex: 2 }}
            label="Log Requests"
            name="customerRiskManagementConfiguration.BndryApiClientConfiguration.LogRequests"
          />
          <TextField
            horizontal
            valueProps={{ flex: 2 }}
            label="API Base Url (Optional)"
            name="customerRiskManagementConfiguration.BndryApiClientConfiguration.ApiBaseUrl"
          />
        </VStack>
      </Box>

      <Box
        w="100%"
        p={4}
        border="1px solid"
        borderColor="cherryButtonDark.50"
        borderRadius="md"
      >
        <Text fontSize="sm">
          <b>Au10Tix API Client Configuration</b>
        </Text>
        <Divider mb={2} />
        <VStack w="100%" spacing={4} alignItems="flex-start">
          <TextField
            horizontal
            valueProps={{ flex: 2 }}
            label="Key Id *"
            name="customerRiskManagementConfiguration.Au10TixApiClientConfiguration.KeyId"
          />
          <TextField
            horizontal
            valueProps={{ flex: 2 }}
            label="Client Id *"
            name="customerRiskManagementConfiguration.Au10TixApiClientConfiguration.ClientId"
          />
          <SwitchField
            horizontal
            valueProps={{ flex: 2 }}
            label="Log Requests"
            name="customerRiskManagementConfiguration.Au10TixApiClientConfiguration.LogRequests"
          />
          <TextField
            horizontal
            valueProps={{ flex: 2 }}
            label="Auth API Base Url (Optional)"
            name="customerRiskManagementConfiguration.Au10TixApiClientConfiguration.AuthApiBaseUrl"
          />
          <SwitchField
            horizontal
            valueProps={{ flex: 2 }}
            label="Use Auth API Base Url For All Requests"
            name="customerRiskManagementConfiguration.Au10TixApiClientConfiguration.UseAuthApiBaseUrlForAllRequests"
          />
        </VStack>
      </Box>
    </VStack>
  );
};
